<template>
    <a
        v-if="registrationStatus.isClickable"
        href="#"
        style="text-decoration: underline"
        :class="registrationStatus.class"
        @click="handleRegistrationStatusClick"
    >
        {{ registrationStatus.status }}
    </a>
    <span v-else :class="registrationStatus.class">
        {{ registrationStatus.status }}
    </span>
</template>

<script>
import {
    VRBO_REGISTRATION_STATUS_COMPLIANT,
    VRBO_REGISTRATION_STATUS_COMPLIANT_ACTION_NEEDED,
    VRBO_REGISTRATION_STATUS_NOT_COMPLIANT,
    VRBO_REGISTRATION_STATUS_NOT_COMPLIANT_ACTION_NEEDED,
    VRBO_REGISTRATION_STATUS_NOT_ALLOWED,
    VRBO_REGISTRATION_STATUS_NONE,
    VRBO_REGISTRATION_STATUS_MAPPING,
} from '../../../constants';

export default {
    data() {
        return {
            feedShare: null,
            registrationStatusClasses: {
                [VRBO_REGISTRATION_STATUS_COMPLIANT]: '',
                [VRBO_REGISTRATION_STATUS_COMPLIANT_ACTION_NEEDED]: 'text-warning',
                [VRBO_REGISTRATION_STATUS_NOT_COMPLIANT]: 'text-danger',
                [VRBO_REGISTRATION_STATUS_NOT_COMPLIANT_ACTION_NEEDED]: 'text-danger',
                [VRBO_REGISTRATION_STATUS_NOT_ALLOWED]: 'text-danger',
                [VRBO_REGISTRATION_STATUS_NONE]: '',
            },
            clickableRegistrationStatuses: [
                VRBO_REGISTRATION_STATUS_COMPLIANT,
                VRBO_REGISTRATION_STATUS_COMPLIANT_ACTION_NEEDED,
                VRBO_REGISTRATION_STATUS_NOT_COMPLIANT,
                VRBO_REGISTRATION_STATUS_NOT_COMPLIANT_ACTION_NEEDED,
                VRBO_REGISTRATION_STATUS_NONE,
            ],
        };
    },
    created() {
        this.feedShare = this.params.data;
    },
    computed: {
        registrationStatus() {
            const registrationStatus = {
                status: this.feedShare.registration_status,
                isClickable: false,
                class: '',
            };
            if (this.feedShare.registration_status in VRBO_REGISTRATION_STATUS_MAPPING) {
                registrationStatus.status = VRBO_REGISTRATION_STATUS_MAPPING[this.feedShare.registration_status];
                registrationStatus.class = this.registrationStatusClasses[this.feedShare.registration_status];
            } else if (this.feedShare.registration_status === null) {
                registrationStatus.status = 'Pending VRBO. Please check back in 24 hours.';
                registrationStatus.class = 'text-danger';
            }

            if (
                this.clickableRegistrationStatuses.indexOf(this.feedShare.registration_status) !== -1 &&
                this.feedShare.registration_data &&
                this.feedShare.registration_data.requirements &&
                this.feedShare.registration_data.requirements.length > 0
            ) {
                registrationStatus.isClickable = true;
            }

            return registrationStatus;
        },
    },
    methods: {
        handleRegistrationStatusClick() {
            this.params.onRegistrationStatusClick &&
                this.params.onRegistrationStatusClick(this.feedShare, this.params.node);
        },
    },
};
</script>
